import { useState, useEffect } from "react";

const Tabs = ({ options, onTabClick, currentTab }) => {
  const [activeTab, setActiveTab] = useState(currentTab || options[0].key);
  useEffect(() => {
    setActiveTab(currentTab);
  }, [currentTab]);

  const handleTabClick = (key) => {
    setActiveTab(key);
    onTabClick(key);
  };

  return (
    <div>
      {options.map((option, index) => (
        <button
          key={index}
          className={`btn px-4 py-2 ${
            activeTab === option.key
              ? "bg-white shadow-sm tw-text-primaryLight tw-font-bold"
              : "text-gray-300 hover:tw-text-primaryLight"
          }`}
          onClick={() => handleTabClick(option.key)}
        >
          {option.label}
          {option.number != null && (
            <span className="tw-ms-1">({option.number})</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
